/**
 * One-time welcome machine: 1 token cost, prize is 1, 3, or 5 tokens.
 * Shown first to logged-in users who have not used it yet.
 */
export const WELCOME_MACHINE_ID = 'welcome-lucky';

export const WELCOME_MACHINE_TOKEN_ICON = '/assets/token-icon.png';

const WELCOME_PRIZE_POOL = [
  { id: 'welcome-1', name: '1 Token', weight: 96, stock: 1, initialStock: 1, imageUrl: '/assets/token-icon.png' },
  { id: 'welcome-3', name: '3 Tokens', weight: 3, stock: 1, initialStock: 1, imageUrl: '/assets/token-icon.png' },
  { id: 'welcome-5', name: '5 Tokens', weight: 1, stock: 1, initialStock: 1, imageUrl: '/assets/token-icon.png' },
];

export function createWelcomeMachine() {
  const prizePoolWeightTotal = WELCOME_PRIZE_POOL.reduce(
    (sum, p) => sum + (Number(p.weight) > 0 ? Number(p.weight) : 0),
    0,
  );
  return {
    id: WELCOME_MACHINE_ID,
    name: 'Welcome Bonus',
    brand: 'PonPon!',
    tagline: 'One-time only · 1 token in, win 1, 3, or 5 tokens!',
    tokenCost: 1,
    prizePool: WELCOME_PRIZE_POOL.map((p) => ({ ...p })),
    prizePoolWeightTotal,
    tags: ['welcome', 'PonPon!'],
    imageUrl: '/assets/ponpon-fallback.svg',
    inventoryAvailable: 1,
    inventoryTotal: 1,
    metadata: null,
    updatedAt: new Date().toISOString(),
    _isFeatured: true,
    _isWelcome: true,
  };
}

export function isWelcomeMachine(machine) {
  return machine?.id === WELCOME_MACHINE_ID || machine?._isWelcome === true;
}
